import { useMemo } from 'react';
import { useUser } from '@increasecard/increase-core';

const PAY_PRODUCT = 'pay';

export function usePayAuthorizations() {
  const user = useUser();

  const payAuthorizations = useMemo(() => {
    if (!user?.productAuthorizations) return [];
    const payEntry = user.productAuthorizations.find((pa) => pa.product === PAY_PRODUCT);
    return payEntry?.authorizations ?? [];
  }, [user]);

  const userHasAuthorization = (authorization) => {
    return payAuthorizations.includes(authorization);
  };

  return { payAuthorizations, userHasAuthorization };
}
